export default {
	init($) {

		/**
		* Set Save credit card as default
		* */
		const savePaymentMethodSelector = '[name="wc-stripe_cc-new-payment-method"]'
		let shouldSavePaymentMethod = true

		const selectSavePaymentMethod = () => {
			$(savePaymentMethodSelector).prop('checked', shouldSavePaymentMethod)
		}

		selectSavePaymentMethod()

		$(document.body)
			.off('change.mbbDefaultStripePaymentMethod', savePaymentMethodSelector)
			.on('change.mbbDefaultStripePaymentMethod', savePaymentMethodSelector, function () {
				shouldSavePaymentMethod = $(this).prop('checked')
			})
			.off('updated_checkout.mbbDefaultStripePaymentMethod')
			.on('updated_checkout.mbbDefaultStripePaymentMethod', selectSavePaymentMethod)

	}
}
